<template>
  <div class="message-box dialog-mask">
    <div class="dialog-content" hide-footer :title="$t('common.presetSelector.title')">
      <div class="modal-content" @scroll="onScroll" ref="contents">
        <template v-for="(image, index) in presetImages">
          <a
            @click="selected(image)"
            href="#"
            :key="image.key"
            :data-index="index"
            :data-image="image.key"
            data-load="false"
          >
            <img class="img-character" :src="image.data || loadingImage" alt="img" />
            <!-- <div class="text-muted">{{image.key.split('/').pop()}}</div> -->
          </a>
        </template>
      </div>
      <div>
        <div class="modal-footer">
          <button class="button" block @click="cancel">{{ $t("common.close") }}</button>
          {{ $t("common.presetSelector.imageSource") }}&nbsp;&nbsp;(
          <a href="http://www.jewel-s.jp/" target="_blank" rel="noopener noreferrer">JewelSaviorFREE</a> )
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import * as s3 from "@/lib/s3";

export default Vue.extend({
  data() {
    return {
      presetImages: [],
      loadingImage: "/img/placeholders/character.png",
      loadingList: false,
      queueingNext: false,
      nextMarker: null,
    };
  },
  created() {
    this.loadNext();
  },
  methods: {
    selected(img) {
      this.$close(img);
    },
    async showPresetImage(e) {
      await this.loadNext();
    },
    async loadNext() {
      this.queueingNext = false;
      this.loadingList = true;
      const { contents, nextMarker } = await s3.listPublicImages(this.nextMarker);
      this.loadingList = false;
      this.nextMarker = nextMarker;

      if (this.queueingNext) {
        setTimeout(this.loadNext, 0);
      }

      this.presetImages.push(...contents);

      // await Promise.all(
      //   contents.map(async (img: any, index) => {
      //     const res = await s3.downloadPublicImage(img.key);
      //     this.$set(img, "data", res);
      //   })
      // );
      setTimeout(this.loadImage, 1);
    },
    loadPrepare() {
      if (this.loadingList) {
        this.queueingNext = true;
      } else {
        this.loadNext();
      }
    },
    cancel() {
      this.$close(false);
    },
    onScroll(e) {
      const { target } = e;
      const bottom = target.scrollTop + target.clientHeight;
      const bottomDistance = target.scrollHeight - bottom;
      if (bottomDistance < 10) {
        this.loadPrepare();
      }

      this.loadImage();
    },
    loadImage() {
      const contents = this.$refs.contents as HTMLDivElement;

      Array.from(contents.children).forEach((elem) => {
        const { dataset } = elem as HTMLAnchorElement;

        const { image, load, index } = dataset;
        if (load === "false") {
          const rects = elem.getBoundingClientRect();
          if (rects.top <= contents.clientHeight + 100) {
            dataset.load = "true";

            s3.downloadPublicImage(image as string).then((res) => {
              this.$set(this.presetImages[Number(index)], "data", res);
            });
          }
        }
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.img-character {
  object-fit: cover;
  width: 150px;
  height: 180px;
  border: 1px solid var(--color-border);
  box-shadow: 3px 3px 5px var(--color-shadow);
  display: inline-block;
  margin: $margin-s;
}

.modal-content {
  height: 70vh;
  width: 80vw;
  overflow-y: scroll;
  background-color: var(--color-bg);
}

.modal-footer {
  color: var(--color-text);

  a {
    color: var(--color-accent);
  }
}

.dialog-mask {
  position: fixed;
  top: -100px;
  right: 0;
  bottom: 0;
  left: 0;
  display: -ms-flexbox;
  display: flex;
  z-index: 9000;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.33);
}

.dialog-content {
  margin: 0 10px;
  padding: 10px 15px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  background-color: var(--color-bg);
  box-shadow: 0 2px 12px 0 var(--color-shadow);
  color: var(--color-text);
}

.button {
  display: inline-block;
  background-color: var(--color-bg-tertiary);
  color: var(--color-text);
  border: 1px solid var(--color-border);
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--color-bg-hover);
  }
}
</style>
